
define('text!views/contentTypeDetail/_contentTypeDetailRow.html',[],function () { return '';});

